import { CallbotReportSummary } from '@/types/callbot'

const clampPercent = (value: number) => Math.max(0, Math.min(100, value))

export function callbotDonutBackground(report: CallbotReportSummary): string {
    const { calls } = report.totals
    if (calls === 0) return '#E9ECF4'

    const reachedEnd = clampPercent((report.outcomes.reached / calls) * 100)
    const notReachedEnd = clampPercent(((report.outcomes.reached + report.outcomes.notReached) / calls) * 100)
    return `conic-gradient(#525AD5 0 ${reachedEnd}%, #D8DCE8 ${reachedEnd}% ${notReachedEnd}%, #E5485D ${notReachedEnd}% 100%)`
}

export function callbotConversionWidth(value: number, percent: number): string {
    if (value === 0) return '0%'
    return `${Math.max(1, clampPercent(percent))}%`
}
